import * as yup from "yup";
import i18n from "../../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const numberMoreThan0Message = () => i18n.t("validation.numberGreaterThanZero", {ns: "common"});

const requiredWhenActive = () =>
    yup.number().when("isActive", {
        is: true,
        then: yup.number().required(requiredMessage).positive(numberMoreThan0Message).integer()
    });

const requiredAlways = () =>
    yup.number().required(requiredMessage).positive(numberMoreThan0Message).integer();

// Acente rolünde yalnızca 4 alan (clickToDoorTime, prepTime, maxOrder, maxPickup) gösteriliyor
// ve orderMerge switch'i (isActive) görünmediği için doğrulama ona bağlı olamaz; bu alanlar
// acentede her zaman zorunlu. prepTimeBufferPercent ve handOverTime acentede hiç gösterilmediği
// için doğrulanmıyor.
export const getMergeOptionsValidation = isAgency =>
    yup.object().shape({
        options: yup.object().shape({
            merge: yup.object().shape({
                isActive: yup.boolean(),
                isPoolMergeActive: yup.boolean(),
                isNowBasedMergeActive: yup.boolean(),
                clickToDoorTime: isAgency ? requiredAlways() : requiredWhenActive(),
                prepTime: isAgency ? requiredAlways() : requiredWhenActive(),
                prepTimeBufferPercent: isAgency ? yup.number() : requiredWhenActive(),
                handOverTime: isAgency ? yup.number() : requiredWhenActive(),
                maxOrder: isAgency ? requiredAlways() : requiredWhenActive(),
                maxPickup: isAgency ? requiredAlways() : requiredWhenActive()
            })
        })
    });

export const mergeOptionsValidation = getMergeOptionsValidation(false);
